import { Grid, Progress } from "@scuf/common";
import CaretIcon from "../Diario/Diario-caret-icon";
import "../Diario/Progress-Diario.css";
import "../Diario/Diario.css";

export default function Scada(body) {
  return (
    <>
      <Grid.Row>
        <Grid.Column
          className="name-column"
          xsWidth="12"
          sWidth="2"
          mWidth="2"
          lWidth="2"
          xlWidth="3"
        >
          SCADA
        </Grid.Column>

        <Grid.Column xsWidth="12" sWidth="2" mWidth="2" lWidth="2" xlWidth="6">
          {body.body.actual && body.body.previus ? (
            <Progress stackedValues={[body.body.actual]} unit="%" />
          ) : (
            <><Progress /><p id="fetch-data">Obteniendo información...</p></>
          )}
        </Grid.Column>

        <CaretIcon body={{ actual: body.body.actual, previus: body.body.previus }} />
      </Grid.Row>
    </>
  );
}